<app-header [forceLightBackground]="true"></app-header>
<div class="provider-my-submissions">
  <div class="provider-my-submissions--layout">
    <app-provider-sidebar class="provider-my-submissions--sidebar"></app-provider-sidebar>
    <div class="provider-my-submissions--content">
      <app-page-header></app-page-header>
      <div class="my-submissions--container">
        <app-my-submissions [showPanelHeader]="false"></app-my-submissions>
      </div>
    </div>
  </div>
</div>
